const HOME_FAQ_SCRIPT_ID = 'home-faq-jsonld';
const FORTALEZA_SEARCH_PATH = '/search?city=Fortaleza&UF=CE';
const ADVERTISE_URL = 'https://captacao.7cantos.com';

const HOME_FAQ = [
  {
    question: 'O que é a 7Cantos?',
    parts: [
      { text: 'A 7Cantos é uma proptech de aluguel residencial. Conectamos proprietários e inquilinos em uma plataforma digital, da busca do imóvel à assinatura do contrato.' },
    ],
  },
  {
    question: 'Em quais cidades a 7Cantos atua?',
    parts: [
      { text: 'Atuamos em São Paulo (SP), Fortaleza (CE), Recife (PE) e Manaus (AM). A sede fica na Av. Washington Soares, 909, Loja 73, Edson Queiroz, Fortaleza – CE.' },
    ],
  },
  {
    question: 'A 7Cantos é uma imobiliária?',
    parts: [
      { text: 'Somos uma empresa de serviços imobiliários focada em locação, com consultores, vistoria, time jurídico e financeiro. O processo é digital, o que deixa a locação mais ágil para o inquilino e para o proprietário.' },
    ],
  },
  {
    question: 'A 7Cantos vende imóveis?',
    parts: [
      { text: 'Não. O foco é aluguel residencial de longo prazo. Não trabalhamos com venda nem com aluguel por temporada.' },
    ],
  },
  {
    question: 'Como alugar um imóvel pela 7Cantos?',
    parts: [
      { text: 'Encontre o imóvel no site, agende a visita online, envie a proposta e a documentação. Depois da aprovação, assine o contrato digitalmente e receba as chaves. ' },
      { text: 'Veja imóveis para alugar', href: FORTALEZA_SEARCH_PATH },
      { text: ' em Fortaleza.' },
    ],
  },
  {
    question: 'Como agendar uma visita a um imóvel?',
    parts: [
      { text: 'Agende pelo site, na data e no horário que preferir. Um consultor encontra você no local com as chaves. Também dá para visitar por videochamada. ' },
      { text: 'Veja imóveis para alugar', href: FORTALEZA_SEARCH_PATH },
      { text: '.' },
    ],
  },
  {
    question: 'Quais documentos preciso para alugar um imóvel?',
    parts: [
      { text: 'Documento com foto (RG ou CNH), comprovante de residência e comprovante de renda, como contracheques, declaração de Imposto de Renda ou extratos bancários.' },
    ],
  },
  {
    question: 'Posso compor renda com outra pessoa para alugar?',
    parts: [
      { text: 'Sim. Dá para compor renda com até mais 3 pessoas para atingir o valor exigido na análise de crédito.' },
    ],
  },
  {
    question: 'Quais garantias locatícias a 7Cantos aceita?',
    parts: [
      { text: 'Caução, em geral equivalente a 3 aluguéis, fiador tradicional e fiança profissional por meio de empresa parceira.' },
    ],
  },
  {
    question: 'Dá para alugar sem fiador?',
    parts: [
      { text: 'Sim. A caução ou a fiança profissional dispensam o fiador tradicional. ' },
      { text: 'Veja imóveis para alugar', href: FORTALEZA_SEARCH_PATH },
      { text: ' para conferir a garantia de cada anúncio.' },
    ],
  },
  {
    question: 'O contrato de aluguel é assinado online?',
    parts: [
      { text: 'Sim. A assinatura é digital e tem validade jurídica, sem cartório e sem imprimir o contrato.' },
    ],
  },
  {
    question: 'Qual o prazo do contrato de aluguel?',
    parts: [
      { text: 'O prazo padrão é de 30 meses, conforme a Lei do Inquilinato (Lei nº 8.245/91).' },
    ],
  },
  {
    question: 'Como anunciar meu imóvel para alugar na 7Cantos?',
    parts: [
      { text: 'A gente agenda uma visita para fotos profissionais e para coletar os dados do imóvel. O anúncio vai ao ar no site e nos principais portais imobiliários. ' },
      { text: 'Anuncie seu imóvel', href: ADVERTISE_URL },
      { text: '.' },
    ],
  },
  {
    question: 'Quanto custa anunciar meu imóvel?',
    parts: [
      { text: 'Anunciar é gratuito. A 7Cantos só é remunerada quando o imóvel é alugado.' },
    ],
  },
  {
    question: 'Preciso dar exclusividade à 7Cantos?',
    parts: [
      { text: 'Não. Você pode anunciar o imóvel em outros lugares ao mesmo tempo.' },
    ],
  },
  {
    question: 'Como funciona a taxa de intermediação?',
    parts: [
      { text: 'Pelo serviço de encontrar e aprovar o inquilino, a 7Cantos retém o valor do primeiro aluguel. A administração do contrato depois disso é opcional.' },
    ],
  },
];

function homeFaqAnswerText(item) {
  return item.parts.map((part) => part.text).join('');
}

function buildHomeFaqJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: HOME_FAQ.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: homeFaqAnswerText(item),
      },
    })),
  };
}

function homeFaqScriptMarkup() {
  const json = JSON.stringify(buildHomeFaqJsonLd()).replace(/</g, '\\u003c');
  return `<script id="${HOME_FAQ_SCRIPT_ID}" type="application/ld+json">${json}</script>`;
}

function injectHomeFaqScript(html) {
  const script = homeFaqScriptMarkup();
  const existing = new RegExp(
    `<script\\s+id="${HOME_FAQ_SCRIPT_ID}"[^>]*>[\\s\\S]*?<\\/script>`,
    'i'
  );
  if (existing.test(html)) {
    return html.replace(existing, script);
  }
  return html.replace('</head>', `${script}\n</head>`);
}

function upsertHomeFaqJsonLd(doc) {
  let script = doc.getElementById(HOME_FAQ_SCRIPT_ID);
  if (!script) {
    script = doc.createElement('script');
    script.id = HOME_FAQ_SCRIPT_ID;
    script.type = 'application/ld+json';
    doc.head.appendChild(script);
  }
  script.textContent = JSON.stringify(buildHomeFaqJsonLd());
}

module.exports = {
  HOME_FAQ_SCRIPT_ID,
  FORTALEZA_SEARCH_PATH,
  ADVERTISE_URL,
  HOME_FAQ,
  homeFaqAnswerText,
  buildHomeFaqJsonLd,
  injectHomeFaqScript,
  upsertHomeFaqJsonLd,
};
